export default __webpack_public_path__ + "static/media/ethereum.73fb6b96.svg";